import React, { useState, useRef } from 'react';
import axios from 'axios';
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

export default function OTPModal({ formData }) {
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const inputsRef = useRef([]);

    const handleChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !otp[index] && index > 0) {
            inputsRef.current[index - 1]?.focus();
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const paste = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        if (paste.length === 0) return;

        const newOtp = [...otp];
        for (let i = 0; i < paste.length; i++) {
            newOtp[i] = paste[i];
        }
        setOtp(newOtp);

        const nextEmpty = newOtp.findIndex((val) => val === '');
        if (nextEmpty >= 0 && nextEmpty < 6) {
            inputsRef.current[nextEmpty]?.focus();
        } else {
            inputsRef.current[5]?.focus();
        }
    };

    const isComplete = otp.every(d => d.length === 1);
    const code = otp.join('');

    const handleSubmit = async () => {
        if (!isComplete || loading) return;
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`${import.meta.env.VITE_API_BACK}/check`, {
                email: formData.email,
                otp: code,
            });

            if (response.status === 200) {
                const dataWithOtp = { ...formData, otp: code };
                localStorage.setItem('contactInformation', JSON.stringify(dataWithOtp));
                window.location.href = '/document';
            } else {
                setError('Code incorrect, veuillez réessayer.');
            }
        } catch (err) {
            setError('Code incorrect, veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-lg p-6 max-w-md w-full text-center animate-fade-in">

                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Phone" size={32} color="var(--color-primary)" strokeWidth={2} />
                </div>

                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    Informations enregistrées
                </h3>

                <p className="text-gray-600 mb-6">
                    Vos informations de contact ont été enregistrées avec succès.
                    <br/>Veuillez entrer le code de vérification envoyé sur votre adresse email ({formData.email}) pour continuer.
                </p>

                <div className="flex justify-center gap-2 mb-6" onPaste={handlePaste}>
                    {otp.map((digit, i) => (
                        <input
                            key={i}
                            id={`otp-${i}`}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            className="w-10 h-12 text-center border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-lg"
                            value={digit}
                            onChange={(e) => handleChange(i, e.target.value)}
                            onKeyDown={(e) => handleKeyDown(i, e)}
                            ref={el => inputsRef.current[i] = el}
                        />
                    ))}
                </div>

                {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

                <Button
                    variant="primary"
                    size="lg"
                    fullWidth
                    disabled={!isComplete || loading}
                    loading={loading}
                    onClick={handleSubmit}
                    iconName="ArrowRight"
                    iconPosition="right"
                    className="order-2 sm:order-1"
                >
                    {loading ? 'Vérification...' : 'Continuer'}
                </Button>
            </div>
        </div>
    );
}